import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    width: '11rem',
    height: '8rem',
    padding: '0.5rem',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: `1px solid ${theme.palette.common.silver}`,
    '&:hover': {
      border: `1px solid ${theme.palette.secondary.main}`,
    },
  },
}));

const Value = ({title, value, onClick}) => {
  const classes = useStyles();
  return (
    <div className={classes.root} onClick={onClick}>
      <Typography  variant="h1" color="primary" align="center" gutterBottom>{value.toLocaleString()}</Typography>
      <Typography variant="body2" align="center">{title}</Typography>
    </div>
  );
};

Value.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

export default Value;
